import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IframeDisplay {
    url: string;
}
const initialState: IframeDisplay = {
    url: '',
};
const IframeDisplaySlice = createSlice({
    name: 'IframeDisplay',
    initialState,
    reducers: {
        setIframeDisplayUrl: (state, action: PayloadAction<string>) => {
            state.url = action.payload;
        },
    },
});

export const { setIframeDisplayUrl } = IframeDisplaySlice.actions;
export default IframeDisplaySlice.reducer;
